module.exports = __webpack_public_path__ + "assets/catalog_placeholder_dark.png";